import { type BaseApiErrorResponse, HttpStatus } from '../types/api.types';
import BaseApiResponseError from './BaseApiResponseError';

export type ConflictErrorArgs<TErrors> = Omit<
  BaseApiErrorResponse<TErrors>,
  'errors' | 'status'
>;
export default class ConflictError<
  TErrors,
> extends BaseApiResponseError<TErrors> {
  constructor({
    code,
    currentAssignment,
    disabledNumberId,
    message,
  }: ConflictErrorArgs<TErrors>) {
    super({
      code,
      currentAssignment,
      disabledNumberId,
      errors: null,
      message,
      status: HttpStatus.Conflict,
    });
  }
}
